export const VERSION = '4.2.7-gogreen';
export const GIT_HASH = '07136ecb2605713a8878db8778ce74979517605f';
export const BUILD_DATE = '';
export const CLIENT_BRAND = 'gg';
